import { useAuth0 } from "@auth0/auth0-react";

const GUEST_FLAG_KEY = "ommuse.guest";
const GUEST_TOKEN_KEY = "ommuse.guest.token";
const GUEST_EXPIRES_AT_KEY = "ommuse.guest.expires_at_ms";

export const markGuestSession = () => {
  try {
    localStorage.setItem(GUEST_FLAG_KEY, "1");
  } catch {
    /* noop */
  }
};

export const clearGuestSession = () => {
  try {
    localStorage.removeItem(GUEST_FLAG_KEY);
    localStorage.removeItem(GUEST_TOKEN_KEY);
    localStorage.removeItem(GUEST_EXPIRES_AT_KEY);
    localStorage.removeItem("ommuse.guest.session_id");
    localStorage.removeItem("ommuse.guest.quota_bytes");
  } catch {
    /* noop */
  }
};

// The flag is "is there a live guest session?" — a token whose recorded
// business expiry hasn't passed. Falls back to the legacy `ommuse.guest` flag
// so existing localStorage from earlier builds keeps working until the user
// next signs in or out.
const readGuestFlag = (): boolean => {
  try {
    const token = localStorage.getItem(GUEST_TOKEN_KEY);
    const expiresRaw = localStorage.getItem(GUEST_EXPIRES_AT_KEY);
    if (token && expiresRaw) {
      const expires = Number(expiresRaw);
      if (Number.isFinite(expires) && expires > Date.now()) return true;
    }
    return localStorage.getItem(GUEST_FLAG_KEY) === "1";
  } catch {
    return false;
  }
};

export const useIsGuest = (): boolean => {
  const { isAuthenticated } = useAuth0();
  if (isAuthenticated) return false;
  return readGuestFlag();
};
